import { useState, useEffect, ReactNode } from 'react';

/**
 * Renders children only after client-side hydration is complete.
 * Use for components that may cause SSG hydration mismatches
 * (portals, browser-API-dependent components, etc.)
 */
const ClientOnly = ({ children }: { children: ReactNode }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return <>{children}</>;
};

export default ClientOnly;
